import { useContext } from 'react';
import EditorContext from '../contexts/EditorContext';

export default () => useContext(EditorContext);
